import { call, select } from 'redux-saga/effects';

import * as D from '../../deps';
import * as ApplicationWorkers from '../workers';

export default [
  {
    actionType: D.ApiActions.LOGOUT_ATTEMPT,
    handler: ApplicationWorkers.onLogoutAttempt,
    concur: 'takeEvery',
  },
  {
    actionType: D.AppConstants.AppActions.TOGGLE_OFFLINE_MODE,
    handler: () => {},
    concur: (() => {
      let wasAppOffline = false;
      return function* whenOffline(mapping, action) {
        // Switch from offline to online
        if (wasAppOffline && !action.payload.isOffline) {
          yield call(ApplicationWorkers.goOnline);
        }
        // Switch from online to offline
        if (!wasAppOffline && action.payload.isOffline) {
          yield call(ApplicationWorkers.goOffline);
        }
        // eslint-disable-next-line require-atomic-updates
        wasAppOffline = yield select(D.AppUtils.isApplicationOffline);
      };
    })(),
  },
  {
    actionType: D.AppConstants.AppActions.DETECT_AD_BLOCKER,
    handler: ApplicationWorkers.detectAdBlockerWatcher,
    concur: 'takeEvery',
  },
  {
    actionType: D.AppConstants.AppActions.OPEN_AD_BLOCKER_MODAL,
    handler: ApplicationWorkers.openAdBlockerModal,
    concur: 'takeEvery',
  },
  {
    actionType: D.AppConstants.AppActions.OPEN_LINKED_PLAYLIST_UNLOCKED_MODAL,
    handler: ApplicationWorkers.openLinkedPlaylistUnlockedModal,
    concur: 'takeEvery',
  },
  {
    actionType: D.AudioPlayerConstants.AudioPlayerActions.ERROR,
    handler: ApplicationWorkers.detectBrowserAutoplayBlocked,
    concur: 'takeEvery',
  },
  {
    actionType: D.AppConstants.AppActions.CLOSE_AD_BLOCKER_MODAL,
    handler: ApplicationWorkers.closeAdBlockerModal,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.AudioPlayer.AudioPlayerActions.AUDIO_PLAY_TRACK,
    handler: ApplicationWorkers.openBrowserAutoplayBlockModal,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.AudioPlayer.AudioPlayerActions.AUDIO_INITIALIZED,
    handler: ApplicationWorkers.initiateHammerAdBlockHandler,
    concur: 'takeOnce',
  },
  {
    actionType: D.AppConstants.AppActions.EXTERNAL_REDIRECT,
    handler: ApplicationWorkers.onExternalRedirect,
  },
  {
    actionType: D.Constants.App.PlaybackMarks.AUDIO_PLAYING,
    handler: ApplicationWorkers.onFirstAudioPlay,
    concur: 'takeOnce',
  },
];
